export default "__VITE_ASSET__kc4RcG9V__"